module.exports = __webpack_public_path__ + "img/Hermit.ecf17d4b.jpg";